import { IonCol, IonGrid, IonIcon, IonItemDivider, IonRow } from '@ionic/react'
import { documentSharp, swapHorizontalSharp, wifiSharp } from 'ionicons/icons'
import { v4 as uuidv4 } from 'uuid'

interface Props {
  title?: string
  procedure: string
  data: any[] | undefined
  setShowActionSheet: any
  setData: any
}

const ViewData = ({ title, procedure, data, setShowActionSheet, setData }: Props) => {
  const prospectoIcon = (negocio: string) => (negocio === 'Portabilidad' ? swapHorizontalSharp : wifiSharp)

  const prospectosRender =
    Array.isArray(data) &&
    procedure === 'prospectos' &&
    data.map((prospecto: any) => (
      <IonRow
        key={uuidv4()}
        className="row item-row"
        id={prospecto.telefono}
        onClick={(e) => {
          setData(prospecto)
          setShowActionSheet(true)
        }}
      >
        <IonCol size="2" className="item-col-lg">
          <IonIcon icon={prospectoIcon(prospecto.negocio)} className="item-icon-center" />
        </IonCol>
        <IonCol size="6" className="item-col-sl">
          {prospecto.apellido} {prospecto.nombre}
        </IonCol>
        <IonCol size="4" className="ion-text-right item-col-sl item-phone">
          {prospecto.telefono}
          <span className={`item-status ${prospecto.estado.toLowerCase()}`}>{prospecto.estado.toUpperCase()}</span>
          <strong>{new Date(prospecto.fechaIngreso).toLocaleString('en-GB').split(',')[0]}</strong>
        </IonCol>
      </IonRow>
    ))

  const proceduresRender =
    Array.isArray(data) &&
    data.map((proc: any) => (
      <IonRow
        key={uuidv4()}
        className="row item-row"
        id={proc.identificationNumber}
        onClick={(e) => {
          setData(proc)
          setShowActionSheet(true)
        }}
      >
        <IonCol size="2" className="item-col-lg">
          <IonIcon icon={documentSharp} className="item-icon-center icon-porta icon-activaciones" />
        </IonCol>
        <IonCol size="6" className="ion-text-start center-text">
          {proc.fullName}
        </IonCol>
        <IonCol size="4" className="right-text item-col-sl item-data">
          {proc.identificationNumber}
        </IonCol>
      </IonRow>
    ))

  const nominativityRender =
    Array.isArray(data) &&
    procedure === 'nominativity' &&
    data.map((nominativity: any) => (
      <IonRow
        key={uuidv4()}
        className="row item-row"
        id={nominativity.metadata.claro.customer.documentNumber}
        onClick={(e) => {
          setData(nominativity)
          setShowActionSheet(true)
        }}
      >
        <IonCol size="2" className="item-col-lg">
          <IonIcon icon={documentSharp} className="item-icon-center icon-porta icon-activaciones" />
        </IonCol>
        <IonCol size="6" className="ion-text-start center-text">
          {nominativity.metadata.claro.customer.lastName} {nominativity.metadata.claro.customer.name}
        </IonCol>
        <IonCol size="4" className="right-text item-col-sl item-data">
          {nominativity.metadata.claro.passport}
          <span className="item-status">{nominativity.metadata.nom.phone.status.toUpperCase()}</span>
        </IonCol>
      </IonRow>
    ))

  const noData = (
    <IonRow key={uuidv4()} className="row item-row no-padding">
      <IonCol size="12" className="ion-text-start item-col-sl ion-padding-top ion-padding-bottom">
        No se encontraron trámites
      </IonCol>
    </IonRow>
  )

  const dataRender = () => {
    if (procedure === 'prospectos') return prospectosRender
    else if (procedure === 'portability' || procedure === 'activacionPP') return proceduresRender
    else return nominativityRender
  }
  return (
    <>
      {procedure === 'prospectos' && <hr className="divider-prospectos" />}
      {title && (
        <IonItemDivider color="light" className="tramites-divider">
          {title}
        </IonItemDivider>
      )}
      <IonGrid className={`prospectos-grid ${data?.length && 'padding-start'}`}>
        {data?.length ? dataRender() : noData}
      </IonGrid>
    </>
  )
}

export default ViewData
